module.exports = __webpack_public_path__ + "static/media/aj-logo.32cd0552.png";